<template>
	<!-- HEADER -->
	<header style="background: rgba(0, 0, 0, 0.3);">
		<div class="video-container">
			<div class="carousel-container">
				<video v-if="topUrlType=='video'" ref="video" class="carousel-video" autoplay
						muted  loop >
						<!-- muted  @ended="onVideoEnded" @play="handlePlay" @pause="handlePause" > -->
						<source :src="topUrl" type="video/mp4">
						<!-- <source src="../../../public/assets/img/TopFirst/VIPTop.mp4" type="video/mp4"> -->
					</video>
                    <img v-else :src="topUrl" alt="">
			</div>
			<div class="overlay">
				<div class="container text-white">
					<div class="row">
						<div class="col-8" style="text-align: left; background: transparent;" v-if="topHoverUrl">
							<img :src="topHoverUrl">
						</div>
						<div class="col-4 "></div>
					</div>
				</div>
			</div>
		</div>
	</header>
	<!--- END HEADER -->
</template>

<script>
export default {
	name: 'topVideo',
	props:{
		topHoverUrl: {
			type: String,
		},
		topUrl:{
			type:String,
			required: true
		},
		topUrlType:{
			type:String,
			required: true
		},
	},
	data() {
		return {
			currentIndex: 0,
		};
	},
	methods: {
		next() {

			// 直接改变 currentIndex 进行视频切换
			this.currentIndex = (this.currentIndex + 1) % this.videos.length;
			this.$nextTick(() => {
				// 确保视图更新后触发播放
				const video = this.$refs.video[this.currentIndex];
				if (video) {
					video.play();
				}
			});
		},
		prev() {
			// 切换到上一个视频，循环播放
			if (this.videos.length > 0) {
				this.currentIndex =
					(this.currentIndex - 1 + this.videos.length) % this.videos.length;
			}

		}, goToSlide(index) {
			if (this.videos.length > 0) {
				this.currentIndex = index
			}
		}, onVideoEnded() {
			this.next();
		}, togglePlay(index) {
			const video = this.$refs.video[index];
			if (video.paused) {
				video.play();
			} else {
				video.pause();
			}
		}, handlePlay() {
			this.isPlaying = true; // 视频开始播放
		},
		handlePause() {
			this.isPlaying = false; // 视频暂停
		},

	},

}
</script>

<style scoped>
@import '../../assets/css/main.css';
@media (max-width: 768px) {
	:deep(.overlay .container .p-5) {
		padding: 1rem !important;
	}
}

@media (max-width: 768px) {
	:deep(.overlay .container .font-weight-light) {
		display: none;
	}
}
.pHeader{
	color: white;
	background: red;
	font-size: 30px;
	display: inline-block;
    vertical-align: top; 
	padding: 0px 15px;
	font-weight: bold;
	font-family: 'DengXian', 'DengXian Mono', sans-serif;
}
:deep(.video-container) {
	position: relative;
	margin: 0 auto;
}

:deep(.video-container video) {
	width: 100%;
	height: auto;
	display: block;
	object-fit: cover;
	max-height: 800px;
}

:deep(.carousel-container) {
	position: relative;
	margin: 0 auto;
	overflow: hidden;
}

:deep(.carousel) {
	display: flex;
	transition: transform 0.5s ease-in-out;
}

:deep(.carousel-video) {
	min-width: 100%;
}

:deep(.overlay) {
	position: absolute !important;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	color: white;
	text-align: center;
	background: rgba(0, 0, 0, 0.4);
	z-index: 1;
	pointer-events: none;
}

:deep(.dots) {
	position: absolute;
	top: unset;
	bottom: 1.25rem;
}
</style>
